import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-BotDetection',
    templateUrl: './BotDetection.component.html'
})
export class BotDetectionComponent implements OnInit {

    consumerID: string;
    whitelist: [];
    blacklist: [];

    data = {
        'consumerID' : this.consumerID,
        'whitelist' : this.whitelist,
        'blacklist' : this.blacklist,
        'plugin' : 'bot-detection'
    };

    constructor() { }

    BotDetection() {
    }
    ngOnInit() {
    }

}
